import useApp from '@providers/App/useApp';
import type { UserDto } from '@api/auth';

export function useCurrentUser(): { currentUser: UserDto | undefined; isLoadingUser: boolean } {
    const { currentUser, isLoadingUser } = useApp();
    return { currentUser, isLoadingUser };
}
